import React, { FC, useState } from 'react'
import { Link } from 'react-router-dom'
import { Logo } from '../../AppLayout/Header'
import { Heading, Button } from '../../System'
import { Testimonials, COURSE_TESTIMONIALS } from './Testimonials'
import { WidthController } from '../../Grid'
import { StyledMarketing } from '.'
import ROUTES from '../../utils/routes'

const CourseMarketing: FC = () => {
  const [isMobileVisible, setIsMobileVisible] = useState(true)

  return (
    <StyledMarketing
      isMobileVisible={isMobileVisible}
      className="auth-marketing"
      background="linear-gradient(135deg, rgba(255, 172, 198, 0.4) 2.88%, rgba(182, 224, 245, 0.4) 100%)"
    >
      <WidthController noHeight noPadding maxWidth={560}>
        <div className="text-container">
          <Logo />
          <Heading>S.O.S. Selling on Social</Heading>
          <Heading type="h2">A Step-By-Step Course to Get More Sales on Social Media</Heading>
          <Testimonials testimonials={COURSE_TESTIMONIALS} />

          <div className="button-prompt">
            <Button type="small" className="scroll-btn" onClick={() => setIsMobileVisible(false)}>
              Sign Up
            </Button>
            <span className="auth-prompt">
              Already have an account? <Link to={ROUTES.user.login}>Sign In</Link>
            </span>
          </div>
        </div>
      </WidthController>
    </StyledMarketing>
  )
}

export default CourseMarketing
